import { ReducerBuilder } from './ReducerBuilder'

const INITIAL_STATE = null
const reducer = ReducerBuilder.create<string, string>(INITIAL_STATE)
  .mapAction('TRANSLATIONS_LOADED', (state: string, lang: string) => lang)
  .build()

export default reducer
